class Drag {
  private isDrag = false;

  private originAxisX = 0;

  constructor(
    private readonly scrollableHTMLElement: { scrollTo: Element['scrollTo']; scrollLeft: Element['scrollLeft'] },
  ) // eslint-disable-next-line no-empty-function
  {}

  pressed = (currentCursorPositionByAxisX: number) => {
    this.isDrag = true;
    this.originAxisX = currentCursorPositionByAxisX;
  };

  unPressed = () => {
    this.isDrag = false;
    this.originAxisX = 0;
  };

  move = (currentCursorPositionByAxisX: number) => {
    if (this.isDrag && this.originAxisX) {
      this.scrollableHTMLElement.scrollTo({
        left: this.scrollableHTMLElement.scrollLeft + (this.originAxisX - currentCursorPositionByAxisX),
      });
    }
  };
}

export const dragToClick = (currentElement: HTMLElement | null): null | (() => void) => {
  if (currentElement) {
    const drag = new Drag(currentElement);

    const onWheel = (event: WheelEvent) => {
      if (event.deltaY === 0) return;
      event.preventDefault();
      currentElement.scrollTo({
        left: currentElement.scrollLeft + event.deltaY,
      });
    };

    const onMouseDown = (event: MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();
      drag.pressed(event.clientX);
    };

    const onMouseUp = () => {
      drag.unPressed();
    };

    const onMouseMove = (event: MouseEvent) => {
      drag.move(event.clientX);
    };

    currentElement.addEventListener('wheel', onWheel);
    currentElement.addEventListener('mousedown', onMouseDown);
    currentElement.addEventListener('mousemove', onMouseMove);
    currentElement.addEventListener('mouseup', onMouseUp);
    currentElement.addEventListener('mouseleave', onMouseUp);

    return () => {
      currentElement.removeEventListener('wheel', onWheel);
      currentElement.removeEventListener('mousedown', onMouseDown);
      currentElement.removeEventListener('mousemove', onMouseMove);
      currentElement.removeEventListener('mouseup', onMouseUp);
      currentElement.removeEventListener('mouseleave', onMouseUp);
    };
  }

  return null;
};
